/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
// 可以优化,不同的角色加载不同的路由 todo

import Vue from 'vue';
import { queryMenuAndPermission } from '@/api/user'
import Router from 'vue-router';
import vm from '@/main'
import {clearLoginInfo} from "@/utils";
import {isURL} from "@/utils/validate";
Vue.use(Router);
const _import = require('./import-views')

const mainRoutes = {
  path: '/',
  component: () => import('@/layouts/main/Main'),
  name: 'main',
  redirect: { name: 'home' },
  meta: { title: '主入口整体布局' },
  children: [
    // 通过meta对象设置路由展示方式
    // 1. isTab: 是否通过tab展示内容, true: 是, false: 否
    // 2. iframeUrl: 是否通过iframe嵌套展示内容, '以http[s]://开头': 是, '': 否
    // 提示: 如需要通过iframe嵌套展示内容, 但不通过tab打开, 请自行创建组件使用iframe处理!
    {
      path: '/home',
      component: () => import('@/views/Home'),
      name: 'home',
      meta: { title: '首页' }
    },
  ],
  beforeEnter(to, from, next) {
    let token = localStorage.getItem('token');
    if (!token) {
      clearLoginInfo();
      // next({ name: 'login' }), // 报路由定向错误, Uncaught (in promise) NavigationDuplicated: Avoided redundant navigation to current location: "/login".
    }
    next()
  }
}
export const routerBase = [
  {
    path: '/',
    redirect: {
      name: 'home'
    }
  },
  {
    path: 'out',
    component: () => import('@/layouts/full-page/FullPage.vue'),
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/index'),
        meta:{
          title: '登录',
        }
      },
    ]
  },


  /*{
    path: "",
    component: () => import('@/layouts/main/Main.vue'),
      title: "平台管理",
      icon: "site",
      noCache: false
    },
    children: [
      {
        name: "addMerchant",
        path: "addMerchant",
        component: () => import('@/views/platformManager/merchant/merchantList/addMerchant'),
        componentName: "addMerchant",
        meta: {
          title: "添加商户",
          titleEn: "添加商户",
          icon: "peoples",
          noCache: false
        },
      },
    ]
  },*/
 /* {
    path: "",
    component: () => import('@/layouts/main/Main.vue'),
    meta: {
      title: "系统管理",
      titleEn: "system management ",
      icon: "site",
      noCache: false
    },
    children: [
      {
        name: "menu",
        path: "menu",
        component: () => import('@/views/systemManager/menu/index'),
        componentName: "menu",
        meta: {
          title: "菜单管理",
          titleEn: "menu management",
          icon: "peoples",
          noCache: false
        },
      },
    ]
  },*/
];

const router = new Router({
    mode: 'hash',
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    isAddDynamicMenuRoutes: false, // 是否已经添加动态(菜单)路由
    routes: routerBase.concat(mainRoutes),
});
/**
 * 判断当前路由类型, global: 全局路由, main: 主入口路由
 * @param {*} route 当前路由
 */
function fnCurrentRouteType(route, globalRoutes = []) {
  var temp = []
  for (var i = 0; i < globalRoutes.length; i++) {
    if (route.path === globalRoutes[i].path) {
      return 'global'
    } else if (globalRoutes[i].children && globalRoutes[i].children.length >= 1) {
      temp = temp.concat(globalRoutes[i].children)
    }
  }
  return temp.length >= 1 ? fnCurrentRouteType(route, temp) : 'main'
}

function deleteSysMenu(menu){
  for (let i = menu.length -1 ; i >= 0; i--) {
    if(menu[i].menuId == 1){
      menu.splice(i,1);
    }
  }
}
router.beforeEach((to, from,next) => {

  if(router.options.isAddDynamicMenuRoutes || fnCurrentRouteType(to, routerBase) === 'global'){
    next();
  }else {
    queryMenuAndPermission().then((data) => {
      // console.table(data.menuList);
      if (data && data.code === 200) {
        if(localStorage.getItem('userName') !== 'admin'){
          // deleteSysMenu(data.menuList); //只在本地调试,todo
        }
        fnAddDynamicMenuRoutes(data.menuList);
        router.options.isAddDynamicMenuRoutes = true
        localStorage.setItem('menuList', JSON.stringify(data.menuList || '[]'))
        localStorage.setItem('permissions', JSON.stringify(data.permissions || '[]'))
        next({ ...to, replace: true })
      } else {
        localStorage.setItem('menuList', '[]')
        localStorage.setItem('permissions', '[]')
        next()
      }
    })
  }

})

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes(menuList = [], routes = []) {
  var temp = [];
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].list && menuList[i].list.length >= 1) {
      temp = temp.concat(menuList[i].list)
    } else if (menuList[i].url && /\S/.test(menuList[i].url)) {

      menuList[i].url = menuList[i].url.replace(/^\//, '');
      if(menuList[i].url.includes('/index')){
        menuList[i].url = menuList[i].url.replace('/index','');
      }
      var route = {
        path: menuList[i].url.replace('/', '-'),
        component: null,
        name: menuList[i].url.replace('/', '-'),
        meta: {
          menuId: menuList[i].menuId,
          title: menuList[i].name,
          isDynamic: true,
          isTab: true,
          iframeUrl: ''
        }
      }
      // url以http[s]://开头, 通过iframe展示
      if (isURL(menuList[i].url)) {
        route['path'] = `i-${menuList[i].menuId}`
        route['name'] = `i-${menuList[i].menuId}`
        route['meta']['iframeUrl'] = menuList[i].url
      } else {
        try {

          route['component'] = _import(`${menuList[i].url}`) || null;
          // route['component'] = ()=>import(`@/views/modules/${menuList[i].url}.vue`) || null
          /*if(menuList[i].name == '策略文章'){
            console.log(menuList[i].url);
          }*/

        } catch (e) { }
      }
      routes.push(route)
    }
  }
  if (temp.length >= 1) {
    fnAddDynamicMenuRoutes(temp, routes);
  } else {
    mainRoutes.name = 'main-dynamic';
    mainRoutes.children = routes;
    router.addRoutes([
      mainRoutes,
      { path: '*', redirect: { name: '404' } }
    ])
    sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(mainRoutes.children || '[]'))
    /*console.log('\n')
    console.log('%c!<-------------------- 动态(菜单)路由 s -------------------->', 'color:blue')
    console.log(mainRoutes.children)
    console.log('%c!<-------------------- 动态(菜单)路由 e -------------------->', 'color:blue')*/
  }
}
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
});
export default router
